import { StatsCard } from './StatsCard';
import { ActivityFeed } from './ActivityFeed';
import { Users, FileText, Brain, Target } from 'lucide-react';
import { GlassCard } from '@/components/design/GlassCard';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

const data = [
  { name: 'Mon', active: 4000, new: 2400 },
  { name: 'Tue', active: 3000, new: 1398 },
  { name: 'Wed', active: 2000, new: 9800 },
  { name: 'Thu', active: 2780, new: 3908 },
  { name: 'Fri', active: 1890, new: 4800 },
  { name: 'Sat', active: 2390, new: 3800 },
  { name: 'Sun', active: 3490, new: 4300 },
];

export const DashboardPage = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-3xl font-bold tracking-tight bg-clip-text text-transparent bg-gradient-to-r from-white to-white/60">Dashboard</h2>
          <p className="text-muted-foreground mt-1">Real-time overview of the political multiverse.</p>
        </div>
      </div>

      {/* Stats Row */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        <StatsCard 
          title="Total Users" 
          value="12,345" 
          change="+12.5%" 
          trend="up" 
          icon={Users}
          color="text-blue-500"
        />
        <StatsCard 
          title="Published Posts" 
          value="142" 
          change="+4.3%" 
          trend="up" 
          icon={FileText}
          color="text-purple-500"
        />
        <StatsCard 
          title="Quizzes Taken" 
          value="8,543" 
          change="+23.1%" 
          trend="up" 
          icon={Brain}
          color="text-pink-500"
        />
        <StatsCard 
          title="Avg Maze Score" 
          value="78.4" 
          change="-2.1%" 
          trend="down" 
          icon={Target}
          color="text-orange-500"
        />
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-7">
        {/* Main Chart */}
        <GlassCard className="col-span-4 min-h-[400px]">
          <h3 className="text-lg font-semibold mb-6">User Engagement</h3>
          <div className="h-[300px] w-full">
            <ResponsiveContainer width="100%" height="100%">
              <AreaChart data={data}>
                <defs>
                  <linearGradient id="colorActive" x1="0" y1="0" x2="0" y2="1">
                    <stop offset="5%" stopColor="#3871fe" stopOpacity={0.3}/>
                    <stop offset="95%" stopColor="#3871fe" stopOpacity={0}/>
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.1)" vertical={false} />
                <XAxis dataKey="name" stroke="rgba(255,255,255,0.4)" tickLine={false} axisLine={false} />
                <YAxis stroke="rgba(255,255,255,0.4)" tickLine={false} axisLine={false} />
                <Tooltip 
                  contentStyle={{ backgroundColor: '#0a0a0b', borderColor: 'rgba(255,255,255,0.1)', borderRadius: '12px' }}
                  itemStyle={{ color: '#fff' }}
                />
                <Area type="monotone" dataKey="active" stroke="#3871fe" strokeWidth={3} fillOpacity={1} fill="url(#colorActive)" />
              </AreaChart>
            </ResponsiveContainer>
          </div>
        </GlassCard>

        {/* Activity Feed */}
        <div className="col-span-3">
          <ActivityFeed />
        </div>
      </div>
    </div>
  );
};
